import styled from 'styled-components';
import {
	neutralWhite, grayBlueMuted, accentBlue, navyDeepest,
	neutral700, navyMedium, grayScrollbar, grayScrollbarHover,
} from '../themes/colors';

export const AccordionWrapper = styled.div<{ $size?: 'small' | 'large' }>`
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
    background-color: ${neutralWhite};
    border: ${({ $size }) => $size === 'large' ? `1px solid ${grayBlueMuted}` : 'none'};
`;

export const AccordionHeader = styled.div<{ $isOpen: boolean }>`
    font-family: "Red Hat Display", sans-serif;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    cursor: pointer;
    background-color: transparent;
    transition: background-color 0.2s ease;
    border: 1px solid transparent;

    &:focus-visible {
        border: 1px solid ${accentBlue};
        border-radius: 2px;
        z-index: 50;
    }

    &:focus:not(:focus-visible) {
        border: 1px solid transparent;
    }
`;

export const Divider = styled.div`
    height: 1px;
    background-color: ${grayBlueMuted};
    margin: 0 16px;
`;

export const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
`;

export const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const Title = styled.h3<{ $size?: 'small' | 'large' }>`
    margin: 0;
    font-weight: 500;
    color: ${navyDeepest};
    font-size: ${({ $size }) => ($size === 'large' ? '18px' : '14px')};
`;

export const ChevronWrapper = styled.div<{ $isOpen: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
    transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
    color: ${neutral700};
`;

export const ExtraIconWrapper = styled.div`
    display: flex;
    align-items: center;
    color: ${navyMedium};
`;

export const CheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const AccordionContentWrapper = styled.div<{ $isOpen: boolean }>`
    display: grid;
    grid-template-rows: ${({ $isOpen }) => ($isOpen ? '1fr' : '0fr')};
    transition: grid-template-rows 0.3s ease-out;
`;

export const AccordionContent = styled.div`
    overflow: hidden;
`;

export const AccordionInnerContent = styled.div<{ $scrollable?: boolean }>`
    padding: 16px;
	padding-right: 8px;
    background-color: ${neutralWhite};
    scrollbar-gutter: stable;
    ${({ $scrollable }) =>
		$scrollable &&
        `
        max-height: 250px;
        overflow-y: scroll;
        scrollbar-width: thin;
        scrollbar-color: ${grayScrollbar} transparent;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background-color: ${grayScrollbar};
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background-color: ${grayScrollbarHover};
        }
    `}
`;

